import { useState, useEffect } from "react";
import { useI18n } from "../lib/i18n.jsx";

export default function OAuthSetup() {
  const { t } = useI18n();
  const [state, setState] = useState("processing");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const installationId = params.get("installation_id");
    const setupAction = params.get("setup_action");

    if (installationId) {
      localStorage.setItem("github-installation-id", installationId);
      localStorage.setItem("github-installation-timestamp", Date.now().toString());
    }

    // Delay to show the message, then redirect back
    setTimeout(() => {
      setState("done");
    }, 1500);

    setTimeout(() => {
      // Try to close or redirect
      try { window.close(); } catch {}
      window.location.href = "https://makeyourcrew-58241.web.app/";
    }, 2500);
  }, []);

  return (
    <div className="oauth-callback-page">
      <div className="oauth-card">
        {state === "processing" && (
          <>
            <div className="spinner" />
            <h2>Installing GitHub App...</h2>
            <p>Setting up the connection. You'll be redirected back to the app.</p>
          </>
        )}
        {state === "done" && (
          <>
            <div className="check-icon big">✓</div>
            <h2>GitHub App Installed!</h2>
            <p>Redirecting back to MakeYourCrew...</p>
          </>
        )}
      </div>
    </div>
  );
}
